import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "small-table"
}

import HolidayTable from '@/components/tables/HolidayTable.vue';
import { useSettingsStore } from '@/stores/setting';
import { onMounted, reactive } from 'vue';
import HolidayModal from '@/components/modals/HolidayModal.vue';
import { useVfm } from 'vue-final-modal';
import { HolidayItem } from '@/services/entities/HolidayItem';
import Loader from '@/components/util/Loader.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'PublicHolidaysView',
  setup(__props) {

const settingsStore = useSettingsStore();
const vfm = useVfm();
const holidayModalId = Symbol("holidayModalId");

const state = reactive({
  value: {} as HolidayItem | [] as HolidayItem[],
  isCreate: false
});

onMounted(async () => {
  await settingsStore.loadHolidays();
});

async function create() {
  await settingsStore.createHolidays(state.value);
  vfm.close(holidayModalId)
  state.value = {} as HolidayItem;
}

async function edit() {
  await settingsStore.updateHoliday(state.value[0]);
  vfm.close(holidayModalId)
  state.value = {} as HolidayItem;
}

function showEditHoliday(holidayId: string) {
  state.isCreate = false;
  state.value = [settingsStore.getHolidays.find(a => a.id == holidayId)];
  vfm.open(holidayModalId);
}

function showCreateHoliday() {
  state.isCreate = true;
  state.value = [{ date: new Date() } as HolidayItem];
  vfm.open(holidayModalId);
}

async function deleteHoliday(holidayId: string) {
  await settingsStore.deleteHoliday(holidayId);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(settingsStore).getHolidaysLoaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(HolidayTable, {
            data: _unref(settingsStore).getHolidays,
            onDelete: deleteHoliday,
            onEdit: showEditHoliday
          }, null, 8, ["data"]),
          _createElementVNode("div", { class: "buttons" }, [
            _createElementVNode("button", {
              class: "accent",
              onClick: showCreateHoliday
            }, [...(_cache[1] || (_cache[1] = [
              _createElementVNode("b", null, "+", -1),
              _createTextVNode(" Add holidays", -1)
            ]))])
          ])
        ]))
      : (_openBlock(), _createBlock(Loader, { key: 1 })),
    _createVNode(HolidayModal, {
      "modal-id": _unref(holidayModalId),
      value: state.value,
      isCreate: state.isCreate,
      onClose: _cache[0] || (_cache[0] = () => _unref(vfm).close(_unref(holidayModalId))),
      onCreate: create,
      onEdit: edit
    }, null, 8, ["modal-id", "value", "isCreate"])
  ], 64))
}
}

})